
import {
    AD_LIST_ATTEMPT,
    AD_LIST_SUCCESS,
    AD_LIST_FAILED,
    AD_LIST_RESTORE,
    ////////////
    AD_MORELIST_ATTEMPT,
    AD_MORELIST_SUCCESS,
    AD_MORELIST_FAILED,
    AD_FEED_NEW_SUCCESS,
    AD_FEED_LIKE_SUCCESS,

    LOGOUT

} from '../types/adListTypes';

const AD_SOURCES = {
    HOME: "home",
    SALE: "sale",
    RENT: "rent",
    EXCHANGE: "exchange",
    DONATION: "donation",
};

const KIND_SOURCE_MAP = {
    1: AD_SOURCES.DONATION,
    2: AD_SOURCES.SALE,
    3: AD_SOURCES.EXCHANGE,
    4: AD_SOURCES.RENT,
};

function prependAd(list, item) {
    if (!item || !item.Id) return list;
    if (list.some((row) => row.Id === item.Id)) return list;
    return [item, ...list];
}

function patchAdLike(list, item) {
    if (!item || !item.Id) return list;
    return list.map((row) => (row.Id === item.Id ? { ...row, Like: item.Like } : row));
}

function prependToSources(sources, item, sourceKeys) {
    const next = { ...sources };
    sourceKeys.forEach((key) => {
        if (!next[key]?.loaded) return;
        next[key] = {
            ...next[key],
            list: prependAd(next[key].list, item),
            page_count: next[key].page_count + 1,
        };
    });
    return next;
}

const INITIAL_STATE = {
    loading: false,
    list: [],
    error: '',
    ////////////////////
    item: {},
    ////////////////////
    loadingMore: false,
    page_index: 0,
    page_size: 0,
    page_count: 0,
    currentSource: null,
    sources: {},
};

function buildSourceEntry(data) {
    return {
        loaded: true,
        list: data.list,
        page_index: data.page,
        page_size: data.size,
        page_count: data.size,
    };
}

function adList(state = INITIAL_STATE, action) {
    switch (action.type) {
        case AD_LIST_ATTEMPT:
            return {
                ...state,
                loading: true,
            }

        case AD_LIST_SUCCESS: {
            const base = {
                ...state,
                loading: false,
                list: action.data.list,
                page_index: action.data.page,
                page_size: action.data.size,
                page_count: action.data.size,
                error: ''
            };

            if (!action.source) {
                return base;
            }

            return {
                ...base,
                currentSource: action.source,
                sources: {
                    ...state.sources,
                    [action.source]: buildSourceEntry(action.data),
                },
            };
        }

        case AD_LIST_FAILED:
            return {
                ...state,
                loading: false,
                error: action.error,
                list: []
            }

        case AD_LIST_RESTORE: {
            const cached = state.sources[action.source];
            if (!cached?.loaded) {
                return state;
            }

            return {
                ...state,
                loading: false,
                list: cached.list,
                page_index: cached.page_index,
                page_size: cached.page_size,
                page_count: cached.page_count,
                currentSource: action.source,
                error: '',
            };
        }
        //////////////////////////////////////////////////
        case AD_MORELIST_ATTEMPT:
            return {
                ...state,
                loadingMore: true,
            }

        case AD_MORELIST_SUCCESS: {
            const source = state.currentSource;
            const newList = state.list.concat(action.data.list);
            const newPageCount = state.page_count + action.data.size;
            const nextState = {
                ...state,
                loadingMore: false,
                page_index: action.data.page,
                page_size: action.data.size,
                page_count: newPageCount,
                list: newList
            };

            if (!source || !state.sources[source]) {
                return nextState;
            }

            return {
                ...nextState,
                sources: {
                    ...state.sources,
                    [source]: {
                        ...state.sources[source],
                        loaded: true,
                        list: newList,
                        page_index: action.data.page,
                        page_size: action.data.size,
                        page_count: newPageCount,
                    },
                },
            };
        }

        case AD_MORELIST_FAILED:
            return {
                ...state,
                loadingMore: false,
                //errorMore: action.error,
            }

        case AD_FEED_NEW_SUCCESS: {
            const source = KIND_SOURCE_MAP[action.item?.KindCommerceId];
            const sourceKeys = [AD_SOURCES.HOME];
            if (source) sourceKeys.push(source);

            const newList = prependAd(state.list, action.item);
            const nextState = {
                ...state,
                list: newList,
                page_count: state.page_count + (newList.length > state.list.length ? 1 : 0),
            };

            if (!state.sources || Object.keys(state.sources).length === 0) {
                return nextState;
            }

            return {
                ...nextState,
                sources: prependToSources(state.sources, action.item, sourceKeys),
            };
        }

        case AD_FEED_LIKE_SUCCESS: {
            const newList = patchAdLike(state.list, action.item);
            const source = state.currentSource;
            const nextState = { ...state, list: newList };

            if (!source || !state.sources[source]) {
                return nextState;
            }

            return {
                ...nextState,
                sources: {
                    ...state.sources,
                    [source]: {
                        ...state.sources[source],
                        list: patchAdLike(state.sources[source].list, action.item),
                    },
                },
            };
        }

        case LOGOUT:
            return INITIAL_STATE;
        default: return state;
    }
};
export default adList;
